import { ApiError, fieldIssues } from '../api';

export const PURCHASES_KEY = ['purchases'] as const;
export const PURCHASES_RESOURCE = 'purchases.purchases';
export const INVESTMENTS_RESOURCE = 'purchases.investments';

export type PurchaseState = 'do_rozpisania' | 'rozpisana' | 'pominieta';
export const STATE_LABELS: Record<PurchaseState, string> = { do_rozpisania: 'Do rozpisania', rozpisana: 'Rozpisana', pominieta: 'Pominięta' };
export type Target = 'katalog' | 'inwestycja' | 'koszt';
export const TARGET_LABELS: Record<Target, string> = { katalog: 'Do katalogu', inwestycja: 'Inwestycja', koszt: 'Koszt' };

/** Amounts and the file are absent for a role that may not see them. */
export type Purchase = {
  id: string;
  source: 'ksef' | 'reczna';
  sellerName: string;
  sellerNip: string;
  invoiceNumber: string;
  issueDate: string;
  dueDate: string | null;
  netGrosze?: number;
  vatGrosze?: number;
  grossGrosze?: number;
  state: PurchaseState;
  skipReason: string;
  fileId?: string | null;
  version: number;
};
export type Allocation = { id: string; target: Target; netGrosze?: number; quantity: number | null; catalogItemId: string | null; catalogItemName: string | null; investmentId: string | null; investmentName: string | null; description: string };
/** F41: the lines of a KSeF invoice (empty for a manual one); the default parts of "Rozpisz". */
export type PurchaseLine = { name: string; quantity: string; netGrosze?: number };
export type PurchaseDetail = Purchase & { allocations: Allocation[]; lines?: PurchaseLine[] };
export type Investment = { id: string; name: string; category: string; purchaseDate: string; netGrosze?: number; notes: string; purchase: { id: string; label: string } | null; version: number };

export const errorText = (e: unknown, fallback: string) => (e instanceof ApiError ? (fieldIssues(e)[0]?.message ?? e.message) : fallback);
/** "2026-10-12" → "12.10.2026". */
export const dayLabel = (day: string) => {
  const [y, m, d] = day.split('-');
  return `${Number(d)}.${m}.${y}`;
};
